export enum EWheelOrder6W {
  eFRONT_LEFT,
  eFRONT_RIGHT,
  eMID_LEFT,
  eMID_RIGHT,
  eREAR_LEFT,
  eREAR_RIGHT,
}
